import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';

import { formatNumber } from '../../../helpers';
import { formatBytes } from '../../../helpers/Files';

const getLineChartOptions = (id, categories, yFormatter, tooltipTitle = '') => ({
  chart: {
    id,
    toolbar: {
      show: false,
    },
    height: '100%',
    zoom: {
      enabled: false,
    },
  },
  colors: ['#28c29b'],
  xaxis: {
    categories,
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    show: false,
  },
  tooltip: {
    y: {
      formatter: yFormatter,
      title: {
        formatter: () => (tooltipTitle),
      },
    },
  },
  markers: {
    size: 6,
    hover: {
      size: 7,
    },
  },
});

const AdminReportsCartLine = ({ report, data, fullPage }) => (
  <Chart
    options={getLineChartOptions(
      report.id,
      data.map(d => (d.period)),
      v => (report.formatter === 'number' ? formatNumber(v) : formatBytes(v)),
      report.tooltipTitle,
    )}
    series={[{
      name: report.id,
      data: data.map(d => (d.count)),
    }]}
    type="line"
    width="100%"
    height={fullPage ? 400 : 300}
  />
);

AdminReportsCartLine.propTypes = {
  report: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  fullPage: PropTypes.bool,
};

AdminReportsCartLine.defaultProps = {
  fullPage: false,
};

export default AdminReportsCartLine;
